import { SELECT_AUTOATTENDANT } from './typeConstants';

export const selectAutoAttendant = (data) => ({
    type: SELECT_AUTOATTENDANT,
    data,
});
